import { useState } from "react";
import { MapPin } from "lucide-react";

/** Keep Google Maps requests off the initial load; preserve the verified listing. */
export function BusinessMap({ mapUrl, title }: { mapUrl: string; title: string }) {
  const [loaded, setLoaded] = useState(false);

  if (loaded) {
    return (
      <iframe
        src={`${mapUrl}&output=embed`}
        title={title}
        className="block h-full w-full border-0"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    );
  }

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 bg-slate-100 p-6 text-center">
      <MapPin className="h-10 w-10 text-primary" aria-hidden="true" />
      <button
        type="button"
        onClick={() => setLoaded(true)}
        className="rounded-md bg-primary px-5 py-3 font-semibold text-white hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary"
      >
        Afficher la carte Google
      </button>
      <p className="max-w-xs text-sm text-muted-foreground">
        La carte se charge à votre demande et se connecte à Google.
      </p>
    </div>
  );
}